import { useEffect } from "react";
import {
  deleteSelectionForKey,
  resetSelectedCablesForKey,
} from "@/lib/keyboard-shortcuts";
import { useSystemStore } from "@/lib/store";

export function useCanvasKeyboard(viewOnly: boolean) {
  useEffect(() => {
    if (viewOnly) return;
    const onKey = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null;
      const isInput =
        target?.tagName === "INPUT" ||
        target?.tagName === "TEXTAREA" ||
        target?.isContentEditable;

      if ((e.metaKey || e.ctrlKey) && e.key === "z" && !e.shiftKey) {
        e.preventDefault();
        useSystemStore.getState().undo();
      } else if ((e.metaKey || e.ctrlKey) && (e.key === "y" || (e.key === "z" && e.shiftKey))) {
        e.preventDefault();
        useSystemStore.getState().redo();
      } else if ((e.metaKey || e.ctrlKey) && e.key === "a" && !isInput) {
        e.preventDefault();
        useSystemStore.getState().selectAll();
      } else if ((e.metaKey || e.ctrlKey) && e.key === "d" && !isInput) {
        e.preventDefault();
        useSystemStore.getState().duplicateSelection();
      } else if ((e.metaKey || e.ctrlKey) && e.key === "c" && !isInput && !e.shiftKey) {
        e.preventDefault();
        useSystemStore.getState().copySelection();
      } else if ((e.metaKey || e.ctrlKey) && e.key === "v" && !isInput && !e.shiftKey) {
        e.preventDefault();
        useSystemStore.getState().pasteFromClipboard();
      } else if (e.key === "Delete" || e.key === "Backspace") {
        if (deleteSelectionForKey(e.key, target, useSystemStore.getState())) {
          e.preventDefault();
        }
      } else if (e.key === "r" || e.key === "R") {
        if (e.metaKey || e.ctrlKey || e.altKey) return;
        if (resetSelectedCablesForKey(e.key, target, useSystemStore.getState())) {
          e.preventDefault();
        }
      } else if (e.key === "Escape") {
        useSystemStore.getState().clearSelection();
        useSystemStore.getState().cancelPendingConnection();
      } else if (
        !isInput &&
        (e.key === "ArrowUp" ||
          e.key === "ArrowDown" ||
          e.key === "ArrowLeft" ||
          e.key === "ArrowRight")
      ) {
        const { selection, nudgeSelection } = useSystemStore.getState();
        if (selection.nodeIds.length === 0) return;
        e.preventDefault();
        const step = e.shiftKey ? 8 : 1;
        const dx = e.key === "ArrowLeft" ? -step : e.key === "ArrowRight" ? step : 0;
        const dy = e.key === "ArrowUp" ? -step : e.key === "ArrowDown" ? step : 0;
        nudgeSelection(dx, dy);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [viewOnly]);
}
